type ComparableVersion = {
  ncFileVersionId: number;
  sequenceNumber: number;
  isActive?: boolean;
};

const pickNearest = <T extends ComparableVersion>(candidates: T[], base: T): T | null => {
  const previous = candidates.filter((v) => v.sequenceNumber < base.sequenceNumber).sort((a, b) => b.sequenceNumber - a.sequenceNumber)[0];
  if (previous) {
    return previous;
  }

  const next = candidates.filter((v) => v.sequenceNumber > base.sequenceNumber).sort((a, b) => a.sequenceNumber - b.sequenceNumber)[0];
  return next ?? candidates[0] ?? null;
};

// Picks the version to compare the base against: nearest previous sequence, else nearest next; prefers active, never the base.
export const resolveComparisonVersion = <T extends ComparableVersion>(versions: T[] | null | undefined, base: T | null | undefined): T | null => {
  if (!versions?.length || !base) {
    return null;
  }

  const candidates = versions.filter((v) => v.ncFileVersionId !== base.ncFileVersionId);
  if (!candidates.length) {
    return null;
  }

  const activeCandidates = candidates.filter((v) => v.isActive);
  return pickNearest(activeCandidates.length ? activeCandidates : candidates, base);
};
